// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__2j9Lh","detailsBorder":"styles_detailsBorder__r7izf"};